module.exports = __webpack_public_path__ + "img/icon_caozuodianji.d854936f.svg";